import moment from 'moment';
import { getTeamUrl } from 'Common';

export default (options) => async (dispatch, getState) => {

  const type = options.key;

  const { sorting, searchTerm, filters } = getState().screens.ProfitAndLoss;

  const params = {};

  params['filter[profit_and_loss]'] = 1;

  if (sorting.columnKey) {
    params.csort = (sorting.order === 'descend' ? '-' : '') + sorting.columnKey;
  }

  if (searchTerm) {
    params.search = searchTerm;
  }

  if (filters.status_key !== 'all') {
    params['filter[status_key]'] = filters.status_key;
  }

  if (filters.phase_key.length > 0) {
    params['filter[phase_key]'] = filters.phase_key.join(',');
  }

  if (filters.client_id.length > 0) {
    params['filter[client_id]'] = filters.client_id.join(',');
  }

  if (filters.contracts_manager.length > 0) {
    params['filter[contracts_manager]'] = filters.contracts_manager.join(',');
  }

  if (Array.isArray(filters.start_between) && filters.start_between.length === 2) {
    params['filter[start_between]'] = filters.start_between.map(date => moment(date).format('YYYY-MM-DD')).join();
  }

  if (Array.isArray(filters.date_between) && filters.date_between.length === 2) {
    params['filter[date_between]'] = filters.date_between.map(date => moment(date).format('YYYY-MM-DD')).join();
  }

  if (filters.outstanding_income) {
    params['filter[outstanding_income]'] = 1;
  }

  let url = `projects/profit_and_loss/export?type=${type}`;

  Object.keys(params).forEach(key => {
    if (params[key]) url += `&${key}=${params[key]}`
  })

  window.location = getTeamUrl(url, 'exports');

}